import { Directive, HostListener } from '@angular/core';
import { Debounce } from 'src/app/shared/directives/debounce/debounce';

@Directive({
  selector: '[debounceInput]',
  standalone: false
})
export class DebounceInputDirective extends Debounce {
  @HostListener('input', ['$event'])
  inputEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    this.textChangedSubject.next(event);
  }
}
